
import './parts/global';
import './parts/sliders.js';
import './parts/header';
import { setUpSliders } from './parts/sliders.js';
import { setUpFooterLinks, setupNavToggle } from './parts/header';
import { fadeLoadLazyImages, setUpNextSectionLinks } from './parts/global';

fadeLoadLazyImages();
setUpFooterLinks();
setUpNextSectionLinks();
setupNavToggle();
setUpSliders();